import type { ApiBoolResult } from '@/types/task-actions'

/** Normalizes `POST` responses that return Swagger `ApiBoolResult` (supports `success`/`Success`, `reason`/`Reason`). */
export function parseApiBoolResult(data: unknown): ApiBoolResult {
  if (data == null || typeof data !== 'object') {
    return { success: false, reason: 'Invalid response from server.' }
  }
  const o = data as Record<string, unknown>
  const successRaw = o.success ?? o.Success
  const reasonRaw = o.reason ?? o.Reason ?? null
  const lockedRaw = o.locked ?? o.Locked
  const errorRaw = o.error ?? o.Error ?? null
  return {
    success: successRaw === true,
    reason: reasonRaw != null && String(reasonRaw).trim() !== '' ? String(reasonRaw) : null,
    locked: lockedRaw === true ? true : undefined,
    error: errorRaw != null && String(errorRaw).trim() !== '' ? String(errorRaw) : null
  }
}
